"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringCV = exports.stringUtf8CV = exports.stringAsciiCV = void 0;
const clarityValue_1 = require("../clarityValue");
const stringAsciiCV = (data) => {
    return { type: clarityValue_1.ClarityType.StringASCII, data };
};
exports.stringAsciiCV = stringAsciiCV;
const stringUtf8CV = (data) => {
    return { type: clarityValue_1.ClarityType.StringUTF8, data };
};
exports.stringUtf8CV = stringUtf8CV;
const stringCV = (data, encoding) => {
    switch (encoding) {
        case 'ascii':
            return stringAsciiCV(data);
        case 'utf8':
            return stringAsciiCV(data);
    }
};
exports.stringCV = stringCV;
//# sourceMappingURL=stringCV.js.map